import { loadStripe } from '@stripe/stripe-js';

// This is your test publishable API key.
// Replace the placeholder key in .env.development with your actual Stripe test publishable key
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_test_REPLACE_WITH_YOUR_STRIPE_TEST_KEY';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = loadStripe(stripePublishableKey);